import * as React from 'react';

export const InsertIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" width={16} height={16} {...props}>
    <path d="M9.33333 9.33333L12.6667 6L9.33333 2.66667L8.39333 3.60667L10.1133 5.33333H4V6.66667H10.1133L8.39333 8.39333L9.33333 9.33333Z" />
    <path d="M10.6667 10.6667H1.33333V1.33333H10.6667V2.66667H12V1.33333C12 0.6 11.4067 0 10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4067 12 12 11.4 12 10.6667V9.33333H10.6667V10.6667Z" />
  </svg>
);
